import { put, select } from "@redux-saga/core/effects";
import axios from "axios";
import { LayoutService } from "../../../services/layout";
import { IErrorType } from "../../types/errors.d";
import { updateLayoutFailure, updateLayoutSuccess } from "../actionCreators";
import { selectLayoutList } from "../selectors";
import { ILayoutForBackEnd, ILayoutList, UpdateLayoutRequestActionType } from "../types";

export function* updateLayoutSaga({ payload: { layout } }: UpdateLayoutRequestActionType) {
    try {
        const layout_: ILayoutList = layout ? layout : yield select(selectLayoutList);

        const field_ids = Object.keys(layout_);
        const requestData: ILayoutForBackEnd[] = field_ids
            .filter(id => !id.includes("tempId"))
            .map(field_id => ({
                field_id,
                layout_info: layout_[field_id],
            }));

        yield LayoutService.setLayout(requestData);

        yield put(updateLayoutSuccess({}));
    } catch (error) {
        if (axios.isAxiosError(error))
            yield put(
                updateLayoutFailure({ errorType: IErrorType.AXIOS, data: error.response ? error.response.data : null }),
            );
        else yield put(updateLayoutFailure({ errorType: IErrorType.NATIVE, data: error }));
    }
}
